import { TMetaAdAccount } from "@/models/meta.model";
import { isDev } from "@/utils/misc";
import axios from "@utils/axios-instance";


const disconnectMetaAccount = async (): Promise<void> => {
    await axios.patch("/integrations/meta/disconnect");
};

export const getMetaConnectionUrl = async (): Promise<string> => {
    const response = await axios.get(`/integrations/meta/connect?local=${isDev}`);
    const data = response.data as { url: string };
    return data.url;
};

export const getAdAccounts = async (): Promise<TMetaAdAccount[]> => {
    const response = await axios.get(`/integrations/meta/list`);
    const data = response.data
    return data
};


const updateCurrentAdAccount = async (account: TMetaAdAccount): Promise<void> => {
    await axios.patch(`/integrations/meta/select`, account);
};




export default {
    disconnectMetaAccount,
    getMetaConnectionUrl,
    getAdAccounts,
    updateCurrentAdAccount,
};
